import ENDPOINT from 'constants/endPoint';
import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

const discoveryLocationApi = {
  async getDiscoveryLocations(params) {
    const query = getParamsFormObject(params);
    const path = `${ENDPOINT.DISCOVERY_LOCATIONS}${query}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async deleteDiscoveryLocation({ id }) {
    const path = ENDPOINT.DISCOVERY_LOCATION_DETAIL(id);

    const response = await axiosClient.delete(path);

    return response.data;
  },
};

export default discoveryLocationApi;
